import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "laptop-message",
  "use": "laptop-message-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"laptop-message\"><path d=\"M28 17h-2v10H4V11h9V9H3a1 1 0 00-1 1v17H0a2 2 0 002 2h26a2 2 0 002-2h-2z\" /><path d=\"M15 3v15l4-3h12V3zm11.33 9H18v-2h8.33zM28 8H18V6h10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/laptop-message.svg
// module id = NVuh
// module chunks = 39 44